/**
 * Generated by orval v7.17.0 🍺
 * Do not edit manually.
 * Mijn PiE BFF
 * OpenAPI spec version: 1.0
 */

export type LegalBasisPersonalDataReason = typeof LegalBasisPersonalDataReason[keyof typeof LegalBasisPersonalDataReason];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const LegalBasisPersonalDataReason = {
  SignedCustomerMandate: 'SignedCustomerMandate',
  LegalObligation: 'LegalObligation',
  PublicTask: 'PublicTask',
  LegitimateInterest: 'LegitimateInterest',
  Other: 'Other',
} as const;
